import { useState } from 'react'
import { useAuth } from '../contexts/AuthContext'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'

export default function Login() {
  const { signIn } = useAuth()
  const navigate = useNavigate()
  const [view, setView] = useState('login') // 'login' | 'forgot' | 'sent'
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  async function handleLogin(e) {
    e.preventDefault()
    setError('')
    setLoading(true)
    const { error } = await signIn(email, password)
    setLoading(false)
    if (error) setError('E-mail ou senha incorretos.')
    else navigate('/')
  }

  async function handleForgot(e) {
    e.preventDefault()
    setError('')
    setLoading(true)
    const redirectTo = window.location.origin + '/reset-password'
    const { error } = await supabase.auth.resetPasswordForEmail(email, { redirectTo })
    setLoading(false)
    if (error) return setError('Não foi possível enviar o e-mail. Tente novamente.')
    setView('sent')
  }

  function goToForgot() {
    setError('')
    setView('forgot')
  }

  function goToLogin() {
    setError('')
    setView('login')
  }

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'var(--bg)', padding: '20px'
    }}>
      <div style={{ width: '100%', maxWidth: '380px' }}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <img src="/favicon.svg" alt="Sharp Radar" style={{ width: 52, height: 52, margin: '0 auto 12px', display: 'block' }} />
          <h1 style={{ fontSize: 20, marginBottom: 4 }}>
            {view === 'forgot' ? 'Redefinir senha' : view === 'sent' ? 'E-mail enviado' : 'Sharp Radar'}
          </h1>
          <p style={{ color: 'var(--text2)', fontSize: 13 }}>Indicadores de Desempenho</p>
        </div>

        <div className="card">
          {view === 'login' && (
            <form onSubmit={handleLogin}>
              {error && <div className="alert alert-error" style={{ marginBottom: 16 }}>{error}</div>}
              <div className="form-group">
                <label>E-mail</label>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)}
                  placeholder="seu@email.com" required autoFocus />
              </div>
              <div className="form-group">
                <label>Senha</label>
                <input type="password" value={password} onChange={e => setPassword(e.target.value)}
                  placeholder="••••••••" required />
              </div>
              <button type="submit" className="btn btn-primary" style={{ width: '100%', marginTop: 6 }} disabled={loading}>
                {loading ? 'Entrando...' : 'Entrar'}
              </button>
              <button
                type="button"
                onClick={goToForgot}
                style={{
                  width: '100%', marginTop: 10, background: 'none', border: 'none',
                  color: 'var(--blue)', fontSize: 13, cursor: 'pointer', padding: '4px 0'
                }}
              >
                Esqueceu a senha?
              </button>
            </form>
          )}

          {view === 'forgot' && (
            <form onSubmit={handleForgot}>
              {error && <div className="alert alert-error" style={{ marginBottom: 16 }}>{error}</div>}
              <p style={{ color: 'var(--text2)', fontSize: 13, marginBottom: 16 }}>
                Informe seu e-mail e enviaremos um link para redefinir a senha.
              </p>
              <div className="form-group">
                <label>E-mail</label>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)}
                  placeholder="seu@email.com" required autoFocus />
              </div>
              <button type="submit" className="btn btn-primary" style={{ width: '100%', marginTop: 6 }} disabled={loading}>
                {loading ? 'Enviando...' : 'Enviar link'}
              </button>
              <button
                type="button"
                onClick={goToLogin}
                style={{
                  width: '100%', marginTop: 10, background: 'none', border: 'none',
                  color: 'var(--text2)', fontSize: 13, cursor: 'pointer', padding: '4px 0'
                }}
              >
                ← Voltar ao login
              </button>
            </form>
          )}

          {view === 'sent' && (
            <div style={{ textAlign: 'center', padding: '8px 0' }}>
              <div style={{
                width: 48, height: 48, borderRadius: '50%', background: 'var(--green-bg)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                margin: '0 auto 16px', fontSize: 22, color: 'var(--green)'
              }}>✓</div>
              <p style={{ fontWeight: 600, marginBottom: 6 }}>Verifique seu e-mail</p>
              <p style={{ color: 'var(--text2)', fontSize: 13, marginBottom: 20 }}>
                Enviamos um link para <strong>{email}</strong>.<br />
                Clique no link para criar uma nova senha.
              </p>
              <button
                type="button"
                onClick={goToForgot}
                style={{
                  background: 'none', border: 'none',
                  color: 'var(--blue)', fontSize: 13, cursor: 'pointer', padding: '4px 0'
                }}
              >
                Reenviar e-mail
              </button>
              <span style={{ color: 'var(--text3)', fontSize: 13, margin: '0 8px' }}>·</span>
              <button
                type="button"
                onClick={goToLogin}
                style={{
                  background: 'none', border: 'none',
                  color: 'var(--text2)', fontSize: 13, cursor: 'pointer', padding: '4px 0'
                }}
              >
                Voltar ao login
              </button>
            </div>
          )}
        </div>

        <p style={{ textAlign: 'center', marginTop: 16, fontSize: 12, color: 'var(--text3)' }}>
          Conta criada pelo administrador do sistema.
        </p>
      </div>
    </div>
  )
}
